import { AzureBlobFSStoreReadSettings } from 'app/model/pipeline/copysource/store-read-settings/azure-blob-fs-read-settings';
import { Metamodel, SapDatasphereForAzureDataLakeStorageGen2LinkedService } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.sapDatasphereForAzureDataLakeStorageGen2.storeRead,
    display: [],
    tags: {
        linkedServiceModel: Metamodel.modelFor(SapDatasphereForAzureDataLakeStorageGen2LinkedService)
    }
})
export class SapDatasphereForAzureDataLakeStorageGen2ReadSettings extends AzureBlobFSStoreReadSettings {}
